export default __webpack_public_path__ + "static/media/disruption_single.f8b91649.svg";